import ApiInvoker from './apiInvoker';

const { protocol } = window.location;
const METHOD_GET = 'GET';
const CONTENT_TYOE_JSON = 'JSON';

const requestObjCache = {};
const generateJavaRequest = (module) => {
  let reqObj = requestObjCache[module];
  if (!reqObj) {
    reqObj = (suburl, data, options) => {
      const api = process.env.VUE_APP_JAPI;
      const SERVER_API = `${api ? `${protocol}${api}` : ''}/api`;
      const nowApi = SERVER_API;
      if (options) {
        const { method, type } = options;
        if (method !== null && method !== METHOD_GET) {
          // java版本默认的请求体格式为json
          if (!type) {
            options.type = CONTENT_TYOE_JSON;
          }
        }
      }
      return ApiInvoker.request(`${nowApi}${module ? `/${module}` : ''}${suburl ? `/${suburl}` : ''}`, data, options, 0, 1);
    };
    requestObjCache[module] = reqObj;
  }
  return reqObj;
};
export default generateJavaRequest;
